import axios from 'axios';
// import moment from 'moment';


export function getAppURL() {
   // console.log('location: ' + window.location.href);
    if (window.location.href.toLowerCase().indexOf('localhost') > -1) {
        return '/api/WS/'//can do this with proxy set in package.json
    }
    else {
        return '../api/WS/';
    }
}





export async function getMemberDTOByIndividualID(id,zip) {
    // var url = getAppURL() + '/getMemberDTOByIndividualID?id=' + id & 'zip=' + zip;
    var url = getAppURL() + `/getMemberDTOByIndividualID?id=${id}&zip=${zip}`;
    //url = '/api/WS/getMemberDTOByIndividualID?id=0000873398&zip=92553-5651'

    console.log('url:',url,'id',id,'zip',zip)
    const res = await axios.get(url);
    return res;
}

